import { Component } from '@angular/core';
import type { CasApplication } from '../../../../../../coverpath-common/classes/coverpath_subclasses/CasApplication';
import { Person } from '../../../../../../common/js/customer/Person';
import { BaseFormComponent } from '../base-form.component';
import { Assumptions } from '../../../../../../common/js/static/Assumptions';
import { Utils } from '../../../../../../common/js/Utils';

@Component({
  selector: 'tele-cmi-case-details',
  templateUrl: './tele-cmi-case-details.component.html',
})
export class TeleCMICaseDetailsComponent extends BaseFormComponent {
  insuredName: string;
  insuredDOB: string;
  ssnLast4: string;
  language: string;
  foreignLanguage: boolean;
  modeOfContact: string;
  modeOfContactIsPhone: boolean;
  bestTimeToCall: string;
  insuredState: string;
  insuredPhone: string;
  insuredEmail: string;

  async ngOnInit() {
    const application: CasApplication = this.appState.controller.customer.application as CasApplication;
    const insuredPerson: Person = application.primaryPolicy.insured.person;
    this.insuredName = insuredPerson.getFullName();
    this.insuredDOB = this.formatterSvc.formatUTCDate(insuredPerson.dob);
    this.ssnLast4 = await this.appState.controller.getPiiValueByKey(insuredPerson.SSN, 4);
    this.language = application.teleCMILanguage;
    this.foreignLanguage = this.language !== 'English';
    this.modeOfContact = Utils.capitalizeFirstLetter(application.teleCMIModeOfContact);
    this.modeOfContactIsPhone = this.modeOfContact === 'Phone';
    this.bestTimeToCall = application.teleCMIBestTimeToCall
      ? Utils.capitalizeFirstLetter(application.teleCMIBestTimeToCall)
      : null;
    this.insuredState = Assumptions.stateValues[insuredPerson.residentialAddress.state];
    this.insuredPhone = Utils.formatPhoneNumber(insuredPerson.phone.number);
    this.insuredEmail = insuredPerson.email;
  }

  updateFromModel() {}
}
